"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ModalViewContent = _styledComponents.default.div.withConfig({
  displayName: "ModalViewContent",
  componentId: "iulxvo-0"
})(["position:absolute;z-index:2;top:72px;display:flex;flex-direction:column;border:1px solid #dfdfdf;width:960px;height:480px;background:#fff;"]);

var _default = ModalViewContent;
exports.default = _default;